export const schemas_en = {
  email: {
    required: 'Please enter your email address.',
    invalid: 'Please enter a valid email address or format.',
  },
  password: {
    required: 'Please enter your password.',
    validation: 'Password must contain at least 8 characters including letters, numbers, and special characters.',
  },
  captchaToken: {
    required: 'Captcha is required.',
  },
  code: {
    required: 'Verification code is required.',
  },
};
